import { useState } from "preact/compat";

import "./style.scss";

import { loggedInUser, menuItemContent, menuItemSet } from "../../types";
import { Auth } from "../auth";
import SubMenu from "./submenu";
import { Icon } from "../../lib/icons";

interface Props {
  links: menuItemSet;
  currentUser?: loggedInUser;
  heading?: string;
  shortHeading?: string;
}

const Header = ({ links, currentUser, heading, shortHeading }: Props) => {
  const [menuOpen, _setMenuOpen] = useState<boolean>(false);

  const setMenuOpen = (open: boolean) => {
    document.body.style.overflow = open ? "hidden" : "auto";
    _setMenuOpen(open);
  };

  const renderNonmobileLink = (entry: menuItemContent) => {
    if ("url" in entry) {
      return <a href={entry.url}>{entry.label}</a>;
    } else if (entry.subMenu) {
      return <SubMenu label={entry.label} entries={entry.subMenu} />;
    }
    return;
  };

  const renderMobileLink = (entry: menuItemContent) => {
    if ("url" in entry) {
      return (
        <div class="list-item" key={entry.url}>
          <a href={entry.url} onClick={() => setMenuOpen(false)}>
            {entry.label}
          </a>
        </div>
      );
    }
    if (entry.subMenu) {
      return (
        <>
          <div class="list-item" key={entry.label}>
            {entry.label}
          </div>
          <div style={{ paddingLeft: "1em" }}>
            {entry.subMenu.map((subEntry) => renderMobileLink(subEntry))}
          </div>
        </>
      );
    }
    return <></>;
  };

  return (
    <header class="header">
      <div class="mobile">
        <h1>
          <button onClick={() => setMenuOpen(true)} class="mobile-menu">
            <Icon
              name="MenuOutlinedIcon"
              style={{ fontSize: "45px", color: "#fff" }}
            />
          </button>
          <span class="subMobile">{shortHeading || heading}</span>
          <span class="nonSubMobile">{heading}</span>
        </h1>

        <div class={"drawer" + (menuOpen ? " open" : "")}>
          <div class="content">
            {links.map((link) => renderMobileLink(link))}
            <div class="list-item" key={"auth"}>
              <Auth
                currentUser={currentUser}
                onClick={() => setMenuOpen(false)}
                asMobile={true}
              />
            </div>
          </div>
          <div class="backdrop" onClick={() => setMenuOpen(false)}></div>
        </div>
      </div>
      <h1 class="nonmobile">{heading}</h1>
      <nav class="nonmobile">
        {links.map((link) => renderNonmobileLink(link))}
        <Auth currentUser={currentUser} />
      </nav>
    </header>
  );
};
export default Header;
